<template>
  <div>
    <v-breadcrumbs :items="crumbs" divider=">"></v-breadcrumbs>
    <h1>{{ this.test.name }}</h1>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar flat dark>
            <v-toolbar-title>Test Details</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-pencil</v-icon>
              </template>
              <v-card>
                <v-toolbar dark flat>
                  <v-toolbar-title>Edit Test Details</v-toolbar-title>
                </v-toolbar>

                <v-card-text>
                  <v-form ref="form" v-model="valid">
                    <v-text-field
                      v-model="test.name"
                      :rules="[v => !!v || 'Name is required']"
                      label="Name"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="test.passingScore"
                      :rules="[v => !!v || 'Passing Score is required']"
                      label="Passing score"
                      type="number"
                      required
                    ></v-text-field>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="saveTest"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="2">
                Name:
                <span class="primary--text">{{ test.name }}</span>
              </v-col>
              <v-col cols="2">
                Passing Score:
                <span class="primary--text">{{ test.passingScore }}</span>
              </v-col>
              <v-col cols="8">
                <test-document-table
                  :testId="this.$route.params.testId"
                ></test-document-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-img
                  v-if="test.thumbnailId"
                  :src="image"
                  width="100%"
                ></v-img>

                <v-file-input
                  label="Upload Video Thumbnail Image"
                  accept="image/*"
                  show-size
                  prepend-icon="mdi-camera-image"
                  @change="uploadImage"
                ></v-file-input>
              </v-col>
              <v-col cols="2">
                <video
                  v-if="test.videoId"
                  :src="video"
                  controls
                  width="100%"
                  name="videoPlayer"
                ></video>
                <v-file-input
                  label="Upload Video"
                  accept="video/*"
                  show-size
                  prepend-icon="mdi-camcorder"
                  @change="uploadVideo"
                  :loading="videoLoading"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <question-card :testId="this.$route.params.testId"></question-card>
        <!-- Question Component -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TestService from "@/services/TestService.js";
import ApiService from "@/services/ApiService.js";
import QuestionCard from "@/components/test/QuestionCard.vue";
import TestDocumentTable from "@/components/tables/TestDocumentTable.vue";
export default {
  components: {
    QuestionCard,
    TestDocumentTable
  },
  data() {
    return {
      dialog: false,
      valid: "",
      loading: false,
      crumbs: [
        {
          text: "Tests",
          disabled: false,
          to: { name: "manageInductions" },
          exact: true
        },
        {
          text: "Details",
          disabled: true
        }
      ],
      test: {},
      locations: [],
      videoLoading: false
    };
  },
  created() {
    this.getTest();
  },
  computed: {
    image() {
      return `${ApiService.getBaseUrl()}test/thumbnail/${
        this.test.thumbnailId
      }`;
    },
    video() {
      return `${ApiService.getBaseUrl()}test/video/${this.test.videoId}`;
    },
    docs() {
      return `${ApiService.getBaseUrl()}test/docs/${
        this.test.additionalDocsId
      }`;
    }
  },
  methods: {
    getTest() {
      TestService.getTest(this.$route.params.testId).then(
        response => (this.test = response)
      );
    },

    saveTest() {
      if (this.$refs.form.validate()) {
        TestService.putTest(this.test)
          .then(() => {
            this.$snackbarSuccess("Test Successfully Updated");
          })
          .catch(() => this.$snackbarError("Test Not Updated"));
        this.dialog = false;
      }
    },
    uploadImage(file) {
      let formData = new FormData();
      formData.append("file", file);
      TestService.postThumbnail(formData, this.test.testId)
        .then(() => {
          this.$snackbarSuccess("Thumnail Successfully Uploaded");
        })
        .finally(this.getTest);
    },
    uploadVideo(file) {
      this.videoLoading = true;
      let formData = new FormData();
      formData.append("file", file);
      TestService.postVideo(formData, this.test.testId)
        .then(() => {
          this.$snackbarSuccess("Video Successfully Uploaded");
        })
        .catch(() => {
          this.$snackbarError("File failed to upload");
        })
        .finally(() => {
          this.getTest, (this.videoLoading = false);
        });
    },
    uploadAdditional(file) {
      let formData = new FormData();
      formData.append("file", file);
      TestService.postDocs(formData, this.test.testId)
        .then(() => {
          this.$snackbarSuccess("Thumnail Successfully Uploaded");
        })
        .finally(this.getTest);
    }
  }
};
</script>
